import {CoinsSections_Levels_BonusToClaim} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wallet/v1/page/sections.types';
import {
  useTrackFeature,
  useTrackFeatureInViewImpression,
} from '@aboutyou/tracking';
import {
  Button,
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  GenericIconName,
  Icon,
  PushNotificationIconName,
  Text,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {startTransition, useState} from 'react';
import coinsWalletBackground from '../../../assets/background-dark.png';
import {ClaimCoinsPopup} from './ClaimCoinsPopup';

export const ClaimCoinsButton: React.FC<{
  bonusToClaim: CoinsSections_Levels_BonusToClaim;
}> = ({bonusToClaim}) => {
  const [isClaiming, setIsClaiming] = useState(false);

  const trackFeature = useTrackFeature();

  const handleClaimBonus = () => {
    trackFeature({
      label: 'coins_bonus_claim_banner',
      eventType: 'click',
    });

    startTransition(() => {
      setIsClaiming(true);
    });
  };

  const {ref} = useTrackFeatureInViewImpression<HTMLDivElement>({
    label: 'coins_bonus_claim_banner',
  });

  return (
    <Wrapper data-testid="coinsWalletClaim" ref={ref}>
      <ClaimBanner data-is-claiming={isClaiming}>
        <Info>
          <BonusValue>
            <Icon
              asset={GenericIconName.CoinsDoubleColor}
              size="S"
              fill={COLORS.White}
            />
            <Text size="px24" weight="heavy" color="White">
              {bonusToClaim.bonus}
            </Text>
          </BonusValue>
          <Text weight="mediumBold" color="White">
            {bonusToClaim.title}
          </Text>
        </Info>
        <CTA
          aria-label={undefined}
          onClick={handleClaimBonus}
          data-testid="coinsWalletClaimButton"
          variant="secondary"
        >
          {bonusToClaim.ctaLabel}
          <Icon
            asset={PushNotificationIconName.Gift}
            size="XS"
            fill={COLORS.White}
          />
        </CTA>
      </ClaimBanner>
      <BonusHint>{bonusToClaim.hint}</BonusHint>
      <ClaimCoinsPopup isOpen={isClaiming} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  --cta-width: 150px;
`;

const ClaimBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  min-height: 78px;
  background: url(${coinsWalletBackground});
  background-size: cover;
  border-radius: 8px;
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: calc(100% - var(--cta-width));
`;

const BonusValue = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const CTA = styled(Button)`
  &&&& {
    max-width: var(--cta-width);
    gap: 6px;
    font-size: ${FONT_SIZES.px12};
    font-weight: ${FONT_WEIGHTS.mediumBold};
    padding: 7px 8px 7px 12px;
    --background-color: rgba(255, 255, 255, 0.2);
    white-space: nowrap;
  }
`;

const BonusHint = styled.span`
  color: ${COLORS['Text.Grey']};
  font-size: ${FONT_SIZES.px10};
  font-weight: ${FONT_WEIGHTS.mediumBold};
  text-align: center;
  line-height: 16px;
  margin-top: -10px;
`;
